import CloseIcon from "@assets/images/CloseModal.svg";
import TruckIcon from "@assets/images/truck.svg";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { DataItemCommon } from "@saleor/deliveryReport/views/utils/sort";
import { renderCollection } from "@saleor/misc";
import moment from "moment-timezone/moment-timezone-utils";
import React from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

import useStyles from "./styles";

export interface SendMailProps {
  isAdmin?: boolean;
  open: boolean;
  onClose: () => void;
  dataItem: DataItemCommon;
  responseItem: any;
}

const ModalGpsTracking: React.FC<SendMailProps> = props => {
  const { open, onClose, dataItem, responseItem } = props;
  const classes = useStyles();
  const intl = useIntl();

  const data = [
    { key: "ทะเบียนรถ", value: responseItem?.truckNo },
    { key: "ตำแหน่งปัจจุบัน", value: responseItem?.boxPosition },
    { key: "ผู้ขนส่ง", value: responseItem?.carrierName },
    { key: "ความเร็ว", value: responseItem?.boxSpeed },
    {
      key: "วันเวลาที่รับสัญญาณครั้งล่าสุด",
      value: responseItem?.boxGpsTime
        ? moment(responseItem?.boxGpsTime, "DD-MM-YYYY HH:mm:ss").format(
            "DD/MM/YYYY HH:mm:ss"
          )
        : ""
    }
  ];

  const eta = moment(responseItem?.eta, "DD-MM-YYYY HH:mm:ss", true);

  const data2 = [
    { key: "เลขที่จ่ายสินค้า", value: responseItem?.dnNo },
    { key: "สถานที่ส่ง", value: responseItem?.destinationName },
    { key: "สถานะรถ", value: dataItem?.lmsStatus },
    {
      key: "เวลาเข้าถึงปลายทาง",
      value: responseItem?.destinationInbound
        ? moment(
            responseItem?.destinationInbound,
            "DD-MM-YYYY HH:mm:ss"
          ).format("DD/MM/YYYY HH:mm:ss")
        : ""
    },
    {
      key: "สถานะประมาณการถึงลูกค้าจากตำแหน่งปัจจุบัน",
      value: eta?.isValid()
        ? eta.format("DD/MM/YYYY HH:mm:ss")
        : responseItem?.eta || ""
    },
    {
      key: "ระยะทางที่เหลือโดยประมาณ (กม.)",
      value: responseItem?.etaDistance
    },
    { key: "เวลาที่ใช้โดยประมาณ", value: responseItem?.etaDuration },
    {
      key: "เวลาถึงโดยประมาณ",
      value: responseItem?.estimatedTime
        ? moment(responseItem?.estimatedTime, "DD-MM-YYYY HH:mm:ss").format(
            "DD/MM/YYYY HH:mm:ss"
          )
        : ""
    },
    {
      key: "ระยะทางจากโรงงานถึงลูกค้า",
      value: responseItem?.accDistance
    },
    {
      key: "วันที่ออกใบจ่ายสินค้า",
      value: responseItem?.goodIssueTime
        ? moment(responseItem?.goodIssueTime, "DD-MM-YYYY HH:mm:ss").format(
            "DD / MM / YYYY"
          )
        : ""
    },
    {
      key: "กำหนดส่งสินค้า",
      value: responseItem?.planDelivery
        ? moment(responseItem?.planDelivery, "DD-MM-YYYY HH:mm:ss").format(
            "DD / MM / YYYY HH:mm:ss"
          )
        : ""
    }
  ];

  return (
    <>
      <Dialog
        data-testid="modal-gps-tracking"
        className={classes.root}
        open={open}
        onClose={onClose}
      >
        <DialogTitle className={classes.dialogTitle}>
          <div className={classes.flexCenter}>
            <SVG
              width={30}
              height={30}
              src={TruckIcon}
              className={classes.icon}
            />
            <MyTypography variant={"h5"}>
              {intl.formatMessage({ defaultMessage: "GPS Tracking" })}
            </MyTypography>
          </div>
          <SVG
            onClick={onClose}
            width={24}
            height={24}
            src={CloseIcon}
            className={classes.closeIcon}
          />
        </DialogTitle>
        <DialogContent className={classes.boxContent}>
          <MyTypography variant={"caption"}>
            {intl.formatMessage({ defaultMessage: "Shipment no." })}
          </MyTypography>
          <Box mb={1}>
            <MyTypography variant={"subtitle1"}>
              {responseItem?.shipment}
            </MyTypography>
          </Box>
          <div className={classes.noteGps}>
            <MyTypography variant={"caption"}>
              <b>หมายเหตุ:</b> การประมาณการอาจมีความผิดพลาด
              กรณีไม่สามารถรับสัญญาณจาก GPS หรือมีการเปลี่ยนเส้นทาง
            </MyTypography>
          </div>
          <div className={classes.table}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2}>
                    <MyTypography variant={"captionBold"}>
                      {intl.formatMessage({ defaultMessage: "ข้อมูลรถ" })}
                    </MyTypography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {renderCollection(data, item => (
                  <TableRow key={item.key}>
                    <TableCell className={classes.cellPrimary}>
                      <MyTypography variant={"body3"}>{item.key}</MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item.value || "-"}
                      </MyTypography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <div className={classes.table}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2}>
                    <MyTypography variant={"captionBold"}>
                      {intl.formatMessage({
                        defaultMessage: "ข้อมูลการจัดส่ง"
                      })}
                    </MyTypography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {renderCollection(data2, item => (
                  <TableRow key={item.key}>
                    <TableCell className={classes.cellPrimary}>
                      <MyTypography variant={"body3"}>{item.key}</MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item.value || "-"}
                      </MyTypography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ModalGpsTracking;
